export interface Header {
  name: string;
  value: string;
}

export function addHeader(currentHeaders: Header[], header: Header) {
  return [...currentHeaders, header];
}

export function addNewHeader(currentHeaders: Header[]) {
  return addHeader(currentHeaders, { name: '', value: '' });
}

export function removeHeader(headers: Header[], index: number) {
  return headers.filter((_, i) => i !== index);
}

export function updateHeaderName(currentHeaders: Header[], index: number, name: string) {
  return currentHeaders.map((header, i) => {
    if (i !== index) {
      return header;
    }

    return {
      name,
      value: header.value,
    };
  });
}

export function updateHeaderValue(currentHeaders: Header[], index: number, value: string) {
  return currentHeaders.map((header, i) => {
    if (i !== index) {
      return header;
    }

    return {
      name: header.name,
      value,
    };
  });
}
